// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"8c58335e","89":"250b8cca","250":"1944df8c","263":"24ac9019","598":"33ef32e2","705":"320133c1","755":"0cb5138c","787":"6a6cd682","871":"2aaacb85","961":"9afaaf67"}[chunkId] + ".chunk.js";
};